import React, { lazy } from 'react'
import Loadable from '../../components/Loadable/Loadable'
import { Page } from '../../Pages'

const DocumentsPage = Loadable(lazy(() => import('./Documents')))

const documentsRoutes = [
	{
		path: Page.documents.path,
		element: <DocumentsPage />
	}
]

export default documentsRoutes
